import { render, staticRenderFns } from "./PrivacyPolicy.vue?vue&type=template&id=db00e4b0&scoped=true"
var script = {}
import style0 from "./PrivacyPolicy.vue?vue&type=style&index=0&id=db00e4b0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db00e4b0",
  null
  
)

export default component.exports